<div>
    <app-setup-password-form [isProfile]="true"></app-setup-password-form>
</div>